/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import {
    GslbBackendComponent,
    GslbFrontendComponent,
    GslbRealServerComponent
} from '../../../components/serviceComponents';
import { Injectable } from '@angular/core';
import { WizardTitleEnum } from '../../../enums';

@Injectable()
export class GslbWizardService {
    /**
     * Get the layer 7 components to be loaded.
     * @param serviceName
     */
    public getGslbComponents(serviceName: string): any {
        switch (serviceName) {
            case WizardTitleEnum.FRONTENDS:
                return GslbFrontendComponent;
            case WizardTitleEnum.BACKENDS:
                return GslbBackendComponent;
            case WizardTitleEnum.REALSERVERS:
                return GslbRealServerComponent;
            // case WizardTitleEnum.TOPOLOGIES:
            //     return TopologyComponent;
        }
    }
}
